module.exports = __webpack_public_path__ + "static/cortex-value-trigger-min-fb89e6724494f5a50189109b197c67b5.png";